// Vendor imports
const { connect } = require('react-redux')
// Common client-v2 imports
const deferDispatch = require('client-v2/common/state/dispatch')
const userModelActions = require('client-v2/common/models/user/actions')
// Entry imports
const articleProfileSlideActions = require('../state/slide-actions')
const ArticleProfileComments = require('./comments-dumb')

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onFormSubmit: dispatchAction(articleProfileSlideActions.addComment),
    onItemDelete: dispatchAction(articleProfileSlideActions.deleteComment),
    onItemReport: dispatchAction(articleProfileSlideActions.reportComment),
    onItemUserClick: dispatchAction(userModelActions.navigateToUserProfile)
  }
}

module.exports = connect(
  null,
  mapDispatchToProps
)(
  ArticleProfileComments
)
